export default "__VITE_ASSET__CdJ2tlcy__"